/**
 * Checks if the current page is a video page with the id of an excluded video in the URL
 * Some specific videos IDs doesn't contain the audience name in the media metadata and need to be filtered
 */
export function isExcludedOhdioJeunesseVideo(): boolean {
  const path = window.location.pathname;
  const excludedIDs = ["618923", "618918"];
  for (let i = 0; i < excludedIDs.length; i++) {
    if (path.indexOf("ohdio/videos/" + excludedIDs[i]) !== -1) {
      return true;
    }
  }
  return false;
}

export function isOhdio(): boolean {
  return window.location.href.includes("ici.radio-canada.ca/ohdio");
}
